<template>
    <div class="form-group">
        <!--        <label v-if="label" :for="name">{{label}}</label>-->
        <label v-if="label" :for="name">{{ label }}</label><span class="text-danger" v-if="required"> *</span>
        <file-pond :id="name" :name="name" :ref="name" :label-idle="Lang.get('messages.upload-label')"
            :allow-multiple="multiple" :accepted-file-types="filesTypes" :server="server" :files="myFiles"
            :disabled="disabled" @removefile="onFileRemoved" @removeFile="onFileRemoved" @remove="onFileRemoved" />
        <small class="form-text text-danger" v-if="localErrors[error_name || name]"
            v-text="localErrors[error_name || name][0]" />
    </div>
</template>

<script>
import vueFilePond from 'vue-filepond';
import ApiService from '@services/api.service';
import Files from '@api/file.api';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import Lang from "lang.js";

export default {
    props: {
        label: {
            type: String
        },

        type: {
            type: String,
            default: 'text'
        },

        name: {
            type: String,
            required: true
        },

        model: {
            type: Object,
            required: true
        },

        errors: {
            type: [Object, Array],
            default: () => ({})
        },

        uploadApi: {
            type: String,
            required: true
        },

        filesTypes: {
            type: String,
            default: 'image/jpeg, image/png'
        },

        disabled: {
            type: Boolean
        },

        multiple: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        error_name: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            myFiles: [],
            server: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    this.$emit('filePondUpload')
                    // fieldName is the name of the input field
                    // file is the actual file object to send
                    const formData = new FormData();
                    formData.append(fieldName, file, file.name);
                    this.localErrors = {}
                    // Send axios post request
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    const axiosConfig = {
                        cancelToken: source.token,
                        onUploadProgress: function (e) {
                            progress(e.lengthComputable, e.loaded, e.total);
                        }
                    }
                    ApiService.post(this.uploadApi, formData, axiosConfig)
                        .then((response) => {
                            if (response.status >= 200 && response.status < 300) {
                                // the load method accepts either a string (id) or an object
                                load(response.data.id);
                                this.onCompleted(response.data.id);
                            } else {
                                // Can call the error method if something is wrong, should exit after
                                error('oh no');
                            }
                        })
                        .catch(function (error) {
                            var errorsData = error.response.data.errors;
                            // Vue.$snotify.error(errorsData[fieldName][0]);
                            // if(errorsData.length){
                            //     console.log(errorsData[fieldName][0])
                            //     // error(errorsData[fieldName][0]);
                            //     Vue.$snotify.error(errorsData[fieldName][0]);
                            // }
                        });

                    // Should expose an abort method so the request can be cancelled
                    return {
                        abort: () => {
                            // This function is entered if the user has tapped the cancel button
                            source.cancel('Operation canceled by the user.');

                            // Let FilePond know the request has been cancelled
                            abort();
                        }
                    };

                },
                revert: (uniqueFileId, load, error) => {
                    Files.remove({ id: uniqueFileId })
                        .then(() => {
                            const index = this.model[this.name].findIndex(item => {
                                if (typeof item === 'object' && item !== null) {
                                    return item.id == uniqueFileId || item.serverId == uniqueFileId;
                                }
                                return item == uniqueFileId;
                            });
                            if (index !== -1) {
                                this.model[this.name].splice(index, 1);
                            }

                            this.$emit('removed', uniqueFileId);
                            this.$snotify.success(this.Lang.get('messages.deleted_successfully'));
                            load();
                        })
                        .catch((err) => {
                            console.error('Delete failed:', err);
                            this.$snotify.error('Failed to delete file');
                            error('Failed to delete file');
                        });
                }
            },
            localErrors: {},
            isUploading: false,
            hasAttemptedUpload: false
        }
    },

    watch: {
        errors: {
            handler(newErrors) {
                // If newErrors is an array (even empty), convert to object or reset
                if (Array.isArray(newErrors)) {
                    this.localErrors = {};
                } else {
                    this.localErrors = { ...newErrors };
                }
            },
            immediate: true
        },
        model(newV, oldV) {
            if (newV[this.name] == null) {
                this.myFiles = [];
            }
        }
    },

    components: {
        FilePond: vueFilePond(FilePondPluginImagePreview, FilePondPluginFileValidateType)
    },

    methods: {
        onFileRemoved(error, file) {
            console.log('removed', file);
            this.$emit('removed', file);
        },
        onCompleted(data) {
            if (this.model[this.name] == null) {
                this.model[this.name] = [];
            }
            this.model[this.name].push(data);
            // this.$set(this.model, this.name, [data]);
            this.$emit('completed', data);
        },
        async handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.isUploading = true;
            this.hasAttemptedUpload = true;

            try {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('name', this.name);

                const response = await axios.post(this.uploadApi, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                this.$set(this.model, this.name, response.data);
                this.$emit('completed', this.name);
                this.$emit('validation-change', true);
                this.localErrors = {};
            } catch (error) {
                if (error.response?.data?.errors) {
                    this.localErrors = error.response.data.errors;
                }
                this.$emit('validation-change', false);
            } finally {
                this.isUploading = false;
            }
        },

        clearError() {
            this.localErrors = {};
            this.$emit('validation-change', true);
        }
    }
}

</script>
